<template>
  <div
    class="sidebar"
    :data-color="sidebarItemColor"
    :data-image="sidebarBackgroundImage"
    :style="sidebarStyle">
    <div class="logo">
      <div class="logo-img" style="text-align: center;margin: auto;">
        <img :src="imgLogo" alt width="180" style=" margin: auto;" />   
        <v-img 
        style="text-align: center;margin: auto;"
        eager="true"
        v-bind:src="myPath" 
        width="200"
        />
      </div>
    </div>
    <div class="sidebar-wrapper" style="text-align: center;">
      <slot name="content"></slot>
      <md-list class="nav">
        <slot>
          <sidebar-link
            v-for="(link, index) in sidebarLinks"
            :key="link.name + index"
            :to="link.path"
            :link="link"
          >
          </sidebar-link>
        </slot>
      </md-list>

      <v-btn class="logout" @click="logout()" text>
        <span style="color:white"> Se déconnecter</span>
        <v-icon color="red">
          mdi-logout
        </v-icon>
      </v-btn>
      
    </div>
  </div>
</template>
<script>
//import SidebarLink from "./SidebarLink.vue";
import io from "socket.io-client";
import router from "@/routes";
import User from "@/services/Users";
export default {
  data: () => ({
      mycount: 1,
      myPath:"" ,//require("@/assets/img/ocp_logo.png"),
   }),
  components: {
    // SidebarLink,
  },
  created() {
    const logoSrc = localStorage.getItem('Logo') !== null ? localStorage.getItem('Logo').toString()+'.png' : 'logo2_.png';
   
    let a = localStorage.getItem("authToken");
    // imgLogo = (localStorage.getItem("Logo") != undefined && localStorage.getItem("Logo") != null) ? localStorage.getItem("Logo").toString() : "logo2_" +".png";
    // (localStorage.getItem("Logo") != undefined && localStorage.getItem("Logo") != null) ? localStorage.getItem("Logo").toString() : "logo2_" +".png"
    User.GetUser(a)
      .then((res) => {
    //      console.log("ddkdkkd " +JSON.stringify(res.data));
          this.myPath = require("@/assets/img/"+res.data.name_company+ ".png")  ;
      })
      .catch((er) => console.log(er));
  },
  props: {
    eager: {
      type: Boolean,
      default: false, // or true, depending on your logic
    },
    title: {
      type: String,
      default: "AgriEdge",
    },
    sidebarBackgroundImage: {
      type: String,
      default: require("@/assets/img/sidebar-2.jpg"),
    },
    imgLogo: {
      type: String,
      default:  function() {
        if (localStorage.getItem('Logo') != null && localStorage.getItem('Logo') != undefined) {
          return require("@/assets/img/"+localStorage.getItem('Logo')+".png");
        } else {
          return require("@/assets/img/logo2_.png");
        }
      }
    },
   /*  img_company: {
      type: String,
      default: require("@/assets/img/ocp_logo.png"),
    }, */
    sidebarItemColor: {
      type: String,
      default: "green",
      validator: (value) => {
        let acceptedValues = ["", "purple", "blue", "green", "orange", "red"];
        return acceptedValues.indexOf(value) !== -1;
      },
    },
    sidebarLinks: {
      type: Array,
      default: () => [],
    },
    autoClose: {
      type: Boolean,
      default: true,
    },
  },
  provide() {
    return {
      autoClose: this.autoClose,
    };
  },
  methods: {
      imageSrc() 
    {
 return   {
      type: String,
      default: require("@/assets/img/logo_.png"),
    } ;
    },
    logout() {
      let socket = io("https://agriedge.ca/irrig_all/", {
        query: { user: localStorage.getItem("authToken") },
      });
      socket.emit("logout", { id: localStorage.getItem("authToken") });

      localStorage.removeItem("authToken");
      router.push("/login");
      //  router.push('/login')
    },
  },
  computed: {
    
    sidebarStyle() {
      return {
        backgroundImage: `url(${this.sidebarBackgroundImage})`,
      };
    },
  
  },
};
</script>
<style>
@media screen and (min-width: 991px) {
  .nav-mobile-menu {
    display: none;
  }
}
.sidebar-wrapper {
  height: 100%;
}

.logout {
 /*  position: absolute;
  bottom: 10em;
  left: 5; */
      top: 10em;
}
</style>
